import {
  MerchantHistoriesAPITypes,
  MerchantHistoriesFetchParamsTypes,
} from 'types/merchantHistories'
import { MerchantHistoriesAPISchemas } from 'schemas/merchantHistoriesSchemas'

import { http } from 'utils'
import { DATASTATUS } from 'constants/status'

export async function getMerchantHistories({
  traderId,
  startDate,
  endDate,
  programUsername,
  pageSize,
  pageNumber,
}: MerchantHistoriesFetchParamsTypes): Promise<MerchantHistoriesAPITypes> {
  const url = `/merchant/histories`
  const data = {
    traderId,
    startDate,
    endDate,
    programUsername,
    pageSize,
    pageNumber,
  }
  const response = await http.post<unknown>(url, data)
  const validatedData = MerchantHistoriesAPISchemas.safeParse(response.data)

  if (!validatedData.success) {
    return {
      data: [],
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }

  return validatedData.data
}